import { NewsAO } from "types/News"
import { createRemoteReducer, RemoteReducer } from "types/Remote"

export const newNewsAOReducer: RemoteReducer<NewsAO[]> =
  createRemoteReducer("newNewsAO")
